// Mapeia uma característica de quarto (texto livre) para um ícone,
// usado na Galeria e na Home para dar mais identidade visual às listas.
import {
  Bath,
  BedDouble,
  Check,
  CookingPot,
  Coffee,
  Snowflake,
  Sofa,
  Tv,
  User,
  Wifi,
  Zap,
} from 'lucide-react'

export function getFeatureIcon(feature) {
  const f = feature.toLowerCase()
  if (f.includes('hóspede')) return User
  if (f.includes('wi-fi') || f.includes('wifi')) return Wifi
  if (f.includes('ar condicionado')) return Snowflake
  if (f.includes('televisão') || f.includes('tv')) return Tv
  if (f.includes('banheiro')) return Bath
  if (f.includes('café')) return Coffee
  if (f.includes('carregador')) return Zap
  if (f.includes('cama')) return BedDouble
  if (f.includes('sofá') || f.includes('sala')) return Sofa
  if (f.includes('cozinha')) return CookingPot
  return Check
}
